import { getSelectedAccountInfo } from '@ibk/shared-auth';
import { baseApi } from '@ibk/shared-config';
export const extractApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getExtract: builder.query({
            query: ({ flow, types, startAt, endAt, minAmount, maxAmount }) => ({
                url: '/v1/accounts/extract',
                params: { flow, types, startAt, endAt, minAmount, maxAmount },
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
        getExtractV2: builder.query({
            query: ({ flow, types, startAt, endAt, minAmount, maxAmount, isBaasV2Enabled }) => {
                const partyId = isBaasV2Enabled ? getSelectedAccountInfo()?.targetId : undefined;
                return {
                    url: '/v2/accounts/extract',
                    params: { flow, types, startAt, endAt, minAmount, maxAmount },
                    forceSelectedAccountInfoAccountId: true,
                    forceAccountantApiBaseUrl: !isBaasV2Enabled,
                    ...(partyId && { headers: { 'x-tr-party-selected': partyId } }),
                };
            },
        }),
        getScheduledExtract: builder.query({
            query: ({ startAt, endAt }) => ({
                url: '/v1/schedule',
                params: { startAt, endAt },
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
        getExtractExportFile: builder.query({
            query: ({ startDate, endDate, format, showDailyBalance = false }) => ({
                url: '/v1/accounts/statement/export',
                params: { startDate, endDate, format, showDailyBalance },
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
        getExtractExportFileV2: builder.query({
            query: ({ startDate, endDate, format, showDailyBalance = false, partyId }) => ({
                url: '/v2/accounts/statement/export',
                params: { startDate, endDate, format: format.toUpperCase(), showDailyBalance },
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: false,
                ...(partyId && { headers: { 'x-tr-party-selected': partyId } }),
            }),
        }),
    }),
});
export const { useLazyGetExtractQuery, useLazyGetExtractV2Query, useLazyGetScheduledExtractQuery, useLazyGetExtractExportFileQuery, useLazyGetExtractExportFileV2Query, } = extractApi;
